import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HtmlHead from "../components/html-head/HtmlHead";
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ApiService } from "../helpers/services/apiSrevice";
import MainService from "../helpers/services/mainService";
import AlertService from "../helpers/services/alertService";
import Marquee from "../components/marquee/Marquee";
import useWindowSize from "../components/hooks/useWindowSize";
import { FaArrowLeft } from "react-icons/fa6";

const RestorePassword = () => {
    const title = "Восстановление пароля";
    const description = "";
    const windowSize = useWindowSize();
    const navigate = useNavigate();
    const { user, token } = useSelector(state => state.user);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const key = params.get("key");
    const email = params.get("email");
    const [isLoading, setIsLoading] = useState(false);
    const [isShowForm, setIsShowForm] = useState(false);
    const [values, setValues] = useState({
        password: "",
        confirmPassword: "",
        key: ""
    });

    useEffect(() => {
        if (user) {
            navigate("/");
        }
    }, [user])

    const [errors, setErrors] = useState({ password: false, confirmPassword: false });

    const validatePassword = (password) => {
        const idValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]([^\s@]+){6,}$/;
        return idValid.test(password);
    };

    useEffect(() => {
        checkKey(key, email);
    }, [key, email])

    const checkKey = (key) => {
        if (!key || !email) { return false; }
        ApiService.checkKey(key, email).then(response => {
            setIsShowForm(true);
        }).catch(error => AlertService.alert("warning", error)).finally(() => {
            setIsLoading(false);
        });
    }

    const checkPassword = () => {
        if (values.password.trim().length) {
            const isPasswordValid = validatePassword(values.password);
            const isConfirmPasswordValid = values.password === values.confirmPassword;
            if (!isPasswordValid || !isConfirmPasswordValid) {
                setErrors({
                    password: !isPasswordValid,
                    confirmPassword: !isConfirmPasswordValid,
                });
                return;
            } else {
                resetPassword();
            }
        } else {
            resetPassword();
        }
    }

    const resetPassword = () => {
        setErrors({ password: false, confirmPassword: false })
    }

    const onSubmit = (event) => {
        event && event.preventDefault();
        if (!key || isLoading) { return false; }
        setIsLoading(true);
        const data = {
            key,
            password: btoa(values.password)
        }
        MainService.callApi({
            api: ApiService.restorePassword,
            data: data,
            cb: response => {
                navigate("/login");
                AlertService.alert("success", "Ваш пароль успешно обновлен!")
            },
            _finally: () => {
                setIsLoading(false);
            }
        });
    }

    return (
        <>
            <Container fluid className="login p-4">
                <HtmlHead title={title} description={description} />
                <div className="d-flex justify-content-between">
                    <Link to="/" className="header-button text-nowrap back-button d-flex gap-1 align-items-center border-1">
                        <FaArrowLeft size={18} className="mt-1" />
                        <span>на главную</span>
                    </Link>
                </div>
                <Row className="mt-5">
                    <Col lg={6} className="mt-3 mt-lg-0">
                        <div className="border-dashed radius-50 p-4 pt-4 bg-white">
                            <p className="title forgot-password-title">ВОССТАНОВЛЕНИЕ ПАРОЛЯ</p>
                            <form onSubmit={onSubmit} className={`form ${!isShowForm ? "disabled" : ""}`} >
                                <div className="mb-4">
                                    <label htmlFor="password">Новый пароль</label>
                                    <input
                                        id="password"
                                        className={`border-1 radius-20 p-3 w-100 ${errors.password ? "error-border" : ""}`}
                                        value={values.password}
                                        type="password"
                                        onChange={(event) => setValues({ ...values, password: event.target.value })}
                                    // onBlur={checkPassword}
                                    />

                                </div>
                                <div className="mb-4">
                                    <label htmlFor="confirmPassword">Подтвердите пароль</label>
                                    <input
                                        id="confirmPassword"
                                        className={`border-1 radius-20 p-3 w-100 ${errors.confirmPassword ? "error-border" : ""}`}
                                        value={values.confirmPassword}
                                        type="password"
                                        onChange={(event) => setValues({ ...values, confirmPassword: event.target.value })}
                                    // onBlur={checkPassword}
                                    />
                                </div>
                                {errors.password && <p className="text-danger mb-1">Пароль должен содержать минимум 6 символов, цифру, букву и специальный символ.</p>}
                                {errors.confirmPassword && <p className="text-danger">Пароли не совпадают.</p>}
                                <input type="hidden" value={values.key} />
                                <div>
                                    <Button
                                        type="submit" variant="dark" className="radius-20 py-2 w-100"
                                        disabled={(values.password.trim().length && values.confirmPassword.trim().length && !errors.password && !errors.confirmPassword) || isLoading ? false : true}
                                    >
                                        {isLoading ? "Отправка..." : "Сохранить новый пароль"}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </Col>
                    <Col lg={6} className="mt-3 mt-lg-0">
                        <div className="radius-50 p-0 p-lg-4 pt-3 pt-lg-0 h-100">
                            <div className="text">
                                <p className="mb-4">
                                    Введите новый пароль и подтвердите его. Мы восстановим доступ к вашему аккаунту.
                                </p>
                                <p className="mb-4">Если у вас возникли проблемы, пожалуйста, обратитесь в службу поддержки:</p>
                                <p className="ms-4">
                                    <span className="d-block"> • Почта: support@govorok-moscow.ru</span>
                                    <span className="d-block"> • Телеграм: @govoroksupport</span>
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Marquee
                content={windowSize.width > 1024 ? ["логопед-дефектолог", "наталья смагина", "логопед-дефектолог", "наталья смагина"] : ["логопед-дефектолог", "Наталья Смагина"]}
                blockClassName="dark-bg"
            />
        </>
    );
};

export default RestorePassword;
